import { useContext } from 'react';
import { ConsumerContext } from './ConsumerProvider';

export default function useConsumerContext() {
    return useContext(ConsumerContext);
};
